/* eslint-disable react/prop-types */
import "./Timeline.css";
import React, { useState, useCallback, useMemo, useContext, useEffect, useRef } from "react";
import { Store } from "../Store/store";
import { API_URL, custom_axios } from "../Common/Common";
import CardContent from "@mui/material/CardContent";
import Linkify from "react-linkify";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FavoriteIcon from "@mui/icons-material/Star";
import FavoriteBorderIcon from "@mui/icons-material/StarBorder";
import CommentIcon from "@mui/icons-material/InsertComment";
import Chip from "@mui/material/Chip";
import ShowTimelineRead from "../Common/ShowTimelineRead";
import ShowTimelineDetail from "../Common/ShowTimelineDetail";

import styled from "@emotion/styled";
import { Switch, FormControlLabel, Badge } from "@mui/material";
import Search from "@mui/icons-material/Search";
import Close from "@mui/icons-material/Close";

//#region something お気に入りと検索のヘッダーstyled
const StyledHeader = styled("div")`
  background-color: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.primary.contrastText};
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
  // background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 5px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  margin-bottom: 5px;
`;
//#endregion
const StyledTypography = styled(Typography)`
  display: inline-block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: pre-line;
`;

export default function Timeline() {
  const { state, dispatch } = useContext(Store);
  const [openRead, setOpenRead] = useState({ open: false, kbn: "timeline", timelineid: null }); //既読ページ
  const [detailOpen, setDetailOpen] = useState({
    isopen: false,
    selectedTimeline: null,
  }); //詳細ページ

  const [favo, setFavo] = useState(false); //お気に入り状態
  const [searchText, setSearchText] = useState(""); //検索文字

  const timelineContainerRef = useRef(null); //リストのref
  const [loadingMore, setLoadingMore] = useState(false); //ローディング状態

  const [lastFetchedId, setLastFetchedId] = useState(null); //スクロール無限ループ制御

  //#region something 170文字までメッセージを表示する関数
  const truncateMessage = (message) => {
    return message.length > 170 ? message.substring(0, 170) + "..." : message;
  };

  // #endregion

  //#region something 既読を押したとき
  const handleReadClick = (timelineid, kbnname) => {
    setOpenRead({ open: true, kbn: "timeline", timelineid: timelineid, kbnname: kbnname });
  };

  const handleReadClose = useCallback(() => {
    setOpenRead({ ...openRead, open: false });
  }, [openRead]);

  const MemoReadMember = useMemo(() => {
    return (
      <ShowTimelineRead
        open={openRead}
        handleClose={handleReadClose}
        timelineid={openRead.timelineid}
        kbnname={openRead.kbnname}
      />
    );
  }, [openRead]);

  // #endregion

  //#region something 詳細を押したとき
  const detailClick = async (timeline) => {
    const sql = `${API_URL}/InsertTimelineRead?timelineid=${timeline.timelineid}&honbuid=${state.honbuid}`;

    const result = await custom_axios(sql);

    if (result.status === 401) {
      return null;
    } else if (result.status === 200) {
      dispatch({ type: "INSERT_TIMELINE_READ", payload: { timelineid: timeline.timelineid } });
      setDetailOpen({
        isopen: true,
        selectedTimeline: timeline,
      });
    } else if (result.status === 204) {
      return null;
    }
  };

  const handleDetailClose = () => {
    setDetailOpen({ isopen: false, selectedTimeline: null });
  };

  const MemoTimelineDetail = useMemo(() => {
    return (
      <ShowTimelineDetail
        open={detailOpen.isopen}
        timelineData={detailOpen.selectedTimeline}
        handleClose={() => handleDetailClose()}
        nowfavo={favo === true ? "1" : "0"}
      />
    );
  }, [detailOpen, handleDetailClose]);

  // #endregion

  //#region something お気に入りを押したとき
  const handleFavoriteClick = async (istoggle = true) => {
    let newFavo;
    if (istoggle) {
      newFavo = !favo;
      setFavo(!favo);
    }

    const data = await fetchTimelineData("", newFavo, searchText);
    dispatch({
      type: "INIT_SELECT_TIMELINE",
      payload: {
        timelines: data ? data.timelines : [],
        lasttimelineid: "",
      },
    });
    setLastFetchedId(null);
  };

  // #endregion

  //#region something 検索を押したとき
  const handleChange = (e) => {
    setSearchText(e.target.value);
    if (e.target.value === "") handleSearchCloseClick();
  };

  const handleKeyDown = (e) => {
    if (e.which === 13 && !e.shiftKey) {
      e.preventDefault();
      if (searchText != "") {
        handleSearchClick();
      }
    }
  };

  const handleSearchClick = async () => {
    const data = await fetchTimelineData("", favo, searchText);
    dispatch({
      type: "INIT_SELECT_TIMELINE",
      payload: {
        timelines: data ? data.timelines : [],
        lasttimelineid: "",
      },
    });
    setLastFetchedId(null);
  };

  const handleSearchCloseClick = async () => {
    setSearchText("");
    const data = await fetchTimelineData("", favo, "");
    dispatch({
      type: "INIT_SELECT_TIMELINE",
      payload: {
        timelines: data ? data.timelines : [],
        lasttimelineid: "",
      },
    });
    setLastFetchedId(null);
  };

  // #endregion

  const fetchTimelineData = async (lasttimelineid = "", favo = false, searchText = "") => {
    if (lasttimelineid === lastFetchedId && lastFetchedId !== null) {
      // console.log("lastFetchedId", lastFetchedId);
      return null;
    }

    const result = await custom_axios(
      API_URL +
        `/GetTimelineList?honbuid=${state.honbuid}
             &lasttimelineid=${lasttimelineid}&searchword=${searchText}&isfavo=${favo === true ? "1" : "0"}`
    );
    const status = result.status;
    if (status === 401) {
      return null;
    }
    if (status === 200) {
      setLastFetchedId(null);
      return result.data;
    }
    if (status === 204) {
      setLastFetchedId(lasttimelineid);
      return null;
    }
  }; //APIからタイムラインを取得

  const fetchMoreData = async () => {
    if (loadingMore || !state.timelines || state.timelines.length === 0) {
      return;
    }
    setLoadingMore(true);
    const data = await fetchTimelineData(state.lasttimelineid, favo, searchText);
    if (data && data.timelines && data.timelines.length > 0) {
      dispatch({
        type: "SELECT_TIMELINE",
        payload: {
          timelines: data.timelines,
          lasttimelineid: data.timelines[data.timelines.length - 1].timelineid,
        },
      });
    }
    setLoadingMore(false);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !favo && !searchText) {
          fetchMoreData();
        }
      },
      {
        threshold: 0.1, //再取得するまでの表示閾値
      }
    );

    if (timelineContainerRef.current) {
      observer.observe(timelineContainerRef.current);
    }
    return () => {
      if (timelineContainerRef.current) {
        observer.unobserve(timelineContainerRef.current);
      }
    };
  }, [fetchMoreData, timelineContainerRef]);

  useEffect(() => {
    async function fetchData() {
      if (state.honbuid === "") return;
      if (state.newtimelineid != null) {
        dispatch({
          type: "DELETE_TIMELINE",
        });
      }
      const data = await fetchTimelineData();
      if (data && data.timelines && data.timelines.length > 0) {
        dispatch({
          type: "SELECT_TIMELINE",
          payload: {
            timelines: data.timelines,
            lasttimelineid: data.timelines[data.timelines.length - 1].timelineid,
          },
        });
      }
    }
    fetchData();
  }, [state.honbuid, state.newtimelineid]);

  return (
    <>
      <div className="timeline-container">
        <StyledHeader>
          <div className="timeline-title">ポスト一覧</div>
          <div className="flex-div">
            <FormControlLabel
              color="primary"
              control={
                <Switch
                  sx={{
                    color: "warning.main", // デフォルトの色
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      // color: "red", // オンになった時の色
                      "& + .MuiSwitch-track": {
                        backgroundColor: "white", // オンになった時のトラックの色
                      },
                    },
                  }}
                />
              }
              label="お気に入り"
              onClick={handleFavoriteClick}
            />
            <div className="chat-search">
              <div className="chat-search-icon">
                <IconButton color="primary" aria-label="send message" onClick={handleSearchClick}>
                  <Search />
                </IconButton>
              </div>
              <input
                placeholder="タイトル検索"
                name="chatsFilter"
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                className="chat-search-field"
                value={searchText}
              />
              <div className="chat-search-icon">
                <IconButton color="primary" aria-label="send message" onClick={handleSearchCloseClick}>
                  <Close />
                </IconButton>
              </div>
            </div>
          </div>
        </StyledHeader>

        {state.timelines.map((timeline, index) => (
          <Card
            key={timeline.timelineid}
            className="timeline-card"
            onClick={() => detailClick(timeline)}
            ref={index === state.timelines.length - 1 ? timelineContainerRef : null}
          >
            {timeline.isfirst === "0" && (
              <Badge overlap="circular" badgeContent="" color="primary" sx={{ bottom: 26, right: 5 }}></Badge>
            )}
            {timeline.filecheck === "1" && (
              <CardMedia
                component="img"
                className="timeline-image"
                src={API_URL + `/GetTimelineThumbnail?timelineid=${timeline.timelineid}`}
                alt={timeline.title}
                size="big"
              />
            )}
            <Box className="timeline-content">
              <Box>
                <Box className="timeline-header">
                  <Typography variant="h6" fontWeight={""}>
                    {timeline.title}
                  </Typography>

                  <div>
                    <Tooltip title="既読">
                      <Chip
                        label={timeline.kbnname}
                        size="small"
                        color={timeline.kbnname === "全員" ? "black" : "primary"}
                        variant="outlined"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReadClick(timeline.timelineid, timeline.kbnname);
                        }}
                        style={{ marginTop: "-10px" }}
                      />
                    </Tooltip>
                  </div>
                </Box>

                <Box className="timeline-flex-end">
                  <Typography variant="body2" color="text.secondary">
                    {timeline.name} - {timeline.time}
                  </Typography>
                </Box>

                <CardContent>
                  <StyledTypography>
                    <Linkify
                      componentDecorator={(decoratedHref, decoratedText, key) => (
                        <a
                          target={`blank${key}`}
                          href={decoratedHref}
                          key={key}
                          onClick={(event) => {
                            event.preventDefault();
                          }}
                        >
                          {decoratedText}
                        </a>
                      )}
                    >
                      {timeline.iswebview === "1" ? "外部サイトを表示します" : truncateMessage(timeline.message)}
                    </Linkify>
                  </StyledTypography>
                </CardContent>
              </Box>

              <Box className="timeline-flex-end">
                {timeline.iscomment === "1" && (
                  <div className="timeline-flex-end">
                    <IconButton aria-label="comment" style={{ color: "gray" }}>
                      <CommentIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                    <Typography variant="body2" sx={{ mr: 1.5 }}>
                      {timeline.comment ?? 0}件
                    </Typography>
                  </div>
                )}
                {timeline.viewcount && (
                  <div className="timeline-flex-end">
                    <IconButton aria-label="comment" style={{ color: "gray" }}>
                      <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                    <Typography variant="body2" sx={{ mr: 1.5 }}>
                      {timeline.viewcount ?? 0}人
                    </Typography>
                  </div>
                )}
                {timeline.ismyfavorite === "1" ? (
                  <FavoriteIcon className="timeline-icon favo" sx={{ fontSize: 20 }} />
                ) : (
                  <FavoriteBorderIcon className="timeline-icon" sx={{ fontSize: 20 }} />
                )}
              </Box>
            </Box>
          </Card>
        ))}
        {MemoReadMember}
        {MemoTimelineDetail}
      </div>
    </>
  );
}
